import UpdateResetPassword from '@nile/banyan/src/Pebbles/update-reset-password/update-reset-password';
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  getHeaderValue,
  toast,
  AppLoader,
  AppContext,
  fetchApi
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import queryString from 'query-string';

const ResetPasswordParent = styled.div`
  height: 100%;
`;

const ResetPasswordPage = (props) => {
  const { history } = props;
  const [loader, setLoader] = useState(true);
  const [renderType, setRenderType] = useState('updatePassword');
  const [isTFARequired, setIsTFARequired] = useState(false);

  const appContext = useContext(AppContext);

  // useEffect(() => {
  //   validateToken();
  // }, []);

  useEffect(() => {
    if (appContext.languageData) validateToken();
  }, [appContext.languageData]);

  const validateToken = async () => {
    const token = queryString.parse(props.location.search).token;
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };
    const validationResponse = await fetchApi(
      `${envConfig.loginRoot}/user/validateactivationtoken?token=${token}`,
      requestOptions
    );

    const validationResponseBool = await validationResponse.json();
    if (validationResponse.status === 200 && validationResponseBool) {
      const response = await fetchApi(
        `${envConfig.loginRoot}/user/tfarequiredbytoken?token=${token}`,
        requestOptions
      );
      const tfaResponse = await response.json();
      setIsTFARequired(tfaResponse);
      if (response.status === 200) {
        if (tfaResponse) setRenderType('passcode');
        else setRenderType('updatePassword');
      } else {
        toast('error', `app.errorCode.${response.status}`);
      }
      setLoader(false);
    } else {
      if (!validationResponseBool) {
        toast('error', `app.errorCode.expired.email.link`);
        history.push(`/login`);
      }
      //Mapping error code other than 200
      else if (validationResponse.status !== 200) {
        toast('error', `app.errorCode.${validationResponse.status}`);
      }
    }
  };
  if (loader)
    return (
      <ResetPasswordParent className="flex center jcenter ">
        <AppLoader />
      </ResetPasswordParent>
    );
  return (
    <UpdateResetPassword
      isTFARequired={isTFARequired}
      resetPassword
      renderType={renderType}
    />
  );
};

export default withRouter(ResetPasswordPage);
